var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPicture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.057,
    height: 20.016,
    viewBox: "0 0 20.057 20.016",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(34,34,34,0.7)",
    d: "M18 9.034l.057-8.862a1.033 1.033 0 0 0-1-1.063h-14a1.033 1.033 0 0 0-1 1.063L2 13.813a1.033 1.033 0 0 0 1 1.062h3.5l4.39-7.78a2.994 2.994 0 0 1 2.2-1.524 2.9 2.9 0 0 1 2.487.905zm0 3l-3.828-4.052a.965.965 0 0 0-.829-.3 1 1 0 0 0-.734.508l-3.773 6.685H17a1.033 1.033 0 0 0 1-1.062zM3.057-3.016h14a3.1 3.1 0 0 1 3 3.188L20 13.813A3.1 3.1 0 0 1 17 17H3a3.1 3.1 0 0 1-3-3.187L.057.172a3.1 3.1 0 0 1 3-3.188zM6 9.563a3.1 3.1 0 0 1-3-3.188 3.1 3.1 0 0 1 3-3.187 3.1 3.1 0 0 1 3 3.187 3.1 3.1 0 0 1-3 3.188zm0-2.125a1.064 1.064 0 0 0 0-2.125 1.064 1.064 0 0 0 0 2.125z",
    transform: "translate(0 3.016)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/picture.8d30ccbc010fb323f8b00dd849f53218.svg";